module.exports = "../images/icons/icon-twitter.svg";